import { AfterViewInit, Component, effect, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { InputType } from '@app/enum/input-type';
import { QuestionComponent } from '@app/components/shared/form/question/question.component';
import { ActivatedRoute, Router } from '@angular/router';
import { EmptySearchComponent } from '@app/components/empty-search/empty-search.component';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { TileComponent } from '@app/components/shared/category/tile/tile.component';
import { ListComponent } from '@app/components/global/list/list.component';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '@app/models/question-base';
import { QuestionControlService } from '@app/services/question/question-control.service';
import { TextboxQuestion } from '@app/models/questions/question-textbox';
import { Services } from '@app/services/fetch/service';
import { CategoriesService } from '@app/services/categories/categories.service';
import { LoadingComponent } from '@app/components/global/loading/loading.component';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { DropDownquestion } from '@app/models/questions/question-dropdown';
import { JsonPipe } from '@angular/common';
import { CalendarAvailabilityService } from '@app/services/calendarAvailability/calendarAvailability.service';

@Component({
  selector: 'app-services-list',
  standalone: true,
  providers: [QuestionControlService],
  imports: [
    QuestionComponent,
    ListComponent,
    EmptySearchComponent,
    TileComponent,
    LoadingComponent
  ],
  styleUrl: './services-list.component.css',
  templateUrl: './services-list.component.html'
})
export class ServicesListComponent extends BaseConfigurableComponent implements OnDestroy, AfterViewInit  {
  @ViewChild(QuestionComponent) questionComponent!: QuestionComponent;
  @ViewChild('myServices') myServices!: ElementRef;
  @ViewChild('branchServices') branchServices!: ElementRef;

  private observer!: MutationObserver;
  protected categoriesService = inject( CategoriesService );
  protected schedulerService = inject( SchedulerStepService );
  protected fetchService = inject( Services );
  protected calendarAvailabilityService = inject( CalendarAvailabilityService );
  private readonly qcs = inject(QuestionControlService)

  questions: QuestionBase<string>[] = [this.FormSearch, this.FormLanguage]
  inputType : typeof InputType = InputType
  form: FormGroup = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);

  target: string = ''
  filtered?: boolean
  categorySelected: string = ''
  branchID: string = this.schedulerService.branchSelected().branchID;


  constructor(override route: ActivatedRoute, private router: Router) {
    super('page')

    this.getOrigin()

    // this.calendarAvailabilityService.staffSelected.set('all')

    this.route.data.subscribe(data => {
      this.target = data['target']
    });
    
    if (this.schedulerService.branchSelected().branchID === undefined)
      this.branchID = this.route.snapshot.paramMap.get('id')!;

    this.fetchService.branchID.set(this.branchID);



    effect(() => {
      if(!this.fetchService.servicesRessource.isLoading()){
        if(this.schedulerService.payload()['services'] !== undefined && this.origin !== 'queue'){
          this.router.navigate(['calendar'])
        }else if(Number(this.deepLink.serv) !== -1){
          const result = Object.values(this.categoriesService.items()[this.textService.language().toUpperCase()])
          .flatMap(category => category)
          .find(service => service.serviceID == Number(this.deepLink.serv));        
          if(result === undefined){
            this.router.navigate(['information', 'wrongService'], { replaceUrl: true, queryParams: { branch: this.branchID } })
            // this.categoriesService.services.set({} as ServiceResponse)
          }else {
            this.schedulerService.setPayload('services', {description: result.name} as CategorySelected)
          }
        }
      }
    })
  }

  ngAfterViewInit() {
    // Force focus after the view is initialized
    const input = document.getElementById('back') as HTMLInputElement;
    input?.focus();
  }


  get isLoading() {
    if (!this.fetchService.servicesRessource.isLoading() && this.myServices !== undefined && this.observer === undefined) {
      this.manageService()
    }
    return this.fetchService.servicesRessource.isLoading() && this.myServices === undefined
  }

  manageService (): void {
    this.observer = new MutationObserver(mutation => {})

    this.manageMyBranchServices()
    setTimeout(() => {
      this.observer.observe(this.myServices.nativeElement, {
        childList: true, // Observe direct children changes
        characterData: true // Observe text content changes
      });
    }, 0);
    
  }

  manageMyBranchServices () : void {
    // if (this.observer) {
    //   this.observer.disconnect();
    // }
   
    this.observer = new MutationObserver( mutations => {
      mutations.forEach( mutation => {
        if (mutation.type === 'childList' || mutation.type === 'characterData'){
          if (Array.from(this.branchServices.nativeElement.classList).includes('servicesList')){
            if (this.questionComponent.searchQuery.nativeElement.value != '' || this.categoriesService.searchQuery() != ''){
              if((this.questionComponent.searchQuery.nativeElement.value.length < 3 && this.questionComponent.searchQuery.nativeElement.value != '') || this.categoriesService.searchQuery().length < 3){

                this.filtered = false
              }else{
                this.filtered = true
              }
            }else{
              this.filtered = false
            }
          }
        }
      })

      if(this.filtered && this.form.get('search')?.value === ''){
        document.getElementById('categorySelected')?.focus()
      }
    })

    this.observer.observe(this.branchServices.nativeElement, {
      childList: true, // Observe direct children changes
      characterData: true // Observe text content changes
    });
  }

  resetSearch(): void {
    this.categorySelected = ''
    this.filtered = false
    this.questionComponent.resetSearch();
  }

  search(category: string): void {
    this.categorySelected = category
    this.filtered = true
  }

  get FormSearch() {
    return new TextboxQuestion ({
      key: 'search',
      placeholder: this.getText().service.main.input.search,
      width: 'w-full',
      search: true,
      order: 2
    })
  }

  get FormLanguage() {
    return new DropDownquestion ({
      key: 'language',
      options: this.textService.DropDownLanguage,
      externalFunction: 'changeLanguage',
      order: 3
    })
  }

  selectEvent(event: { function: string; value: string | CategorySelected | Branch }): void {
    if (event.function === 'changeLanguage'){
      if(this.form.get('search')?.value !== '') {
        document.getElementById('clearSearch')?.click()
      }
      const searchQuery = this.categoriesService.searchQuery().trim().toLowerCase();
      const selectedLanguage = event.value.toString().toUpperCase();

      const serviceList = this.categoriesService.services().serviceList;

      // Step 1: Find the categoryOrder that matches the search query
      const matchedCategory = serviceList.find(service => 
        service.service.category.toLowerCase() === searchQuery
      );

      const catOrd = matchedCategory ? matchedCategory.service.categoryOrder : -1;

      // Step 2: Find the matching service with same categoryOrder and selected language
      const finalMatch = serviceList.find(service => {
        const { category, categoryOrder, language } = service.service;
        return categoryOrder === catOrd && language.toUpperCase() === selectedLanguage;
      });

      if (finalMatch) {
        const { category } = finalMatch.service;
        this.categorySelected = category;
        this.categoriesService.searchQuery.set(category);
      } else {
        this.categorySelected = ''
      }
      

      this.textService.setLanguage(event.value.toString())
    }else if (event.function === 'selectService'){
      this.schedulerService.setPayload('services', event.value as CategorySelected)
      this.categoriesService.searchQuery.set('')
      if (this.origin === 'queue') {
        this.schedulerService.setPayload('calendar', {description: ''})
      }
      this.router.navigate([(this.origin === 'queue') ? 'contact-info' :'/calendar'], {queryParamsHandling: 'merge'});
    }
  }

  ngOnDestroy(): void {
    this.filtered = false
    this.categorySelected = ''
    if(this.questionComponent)
      this.questionComponent.resetSearch();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}